import {darken, type Theme, type Components} from "../..";

type BanderoleOverrides = Components<Theme>["MuiBanderole"];

const overrides: BanderoleOverrides = {
    styleOverrides: {
        label: (ownerState) => {
            const {theme} = ownerState;

            return {
                ...(ownerState.color === "default" && {
                    backgroundColor: theme.color.fill.accent.default,
                    color: theme.color.text.default,
                    ...(ownerState.disableFold !== true && {
                        "&::before": {
                            backgroundColor: darken(
                                theme.color.fill.accent.default,
                                0.5,
                            ),
                        },
                    }),
                }),

                ...(ownerState.color === "critical" && {
                    color: theme.color.text.inverted.default,
                    backgroundColor: theme.color.icon.critical,

                    ...(ownerState.disableFold !== true && {
                        "&::before": {
                            backgroundColor: darken(theme.color.icon.critical, 0.5),
                        },
                    }),
                }),
            };
        },
    },
    defaultProps: {
        color: "default",
    },
};

export default overrides;
